import styled from "styled-components";
import { HeadLine1 } from "../../../../../components/typography/styled";

export const Container = styled.div`
  display:flex;
  justify-content: space-between;
  flex-direction: column;
`
export const CreateContainer = styled.div`
  justify-content: space-between;
  display: inline-flex;
  align-items: flex-start;
`
export const TitleBig = styled(HeadLine1)`
  color:${({theme}) => theme.palette[850]};
  margin-top: 20px;
  margin-bottom: 20px;
`
